module.exports = __webpack_public_path__ + "static/index/img/baikal-1001.cf9d63b2.jpg";